// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3liMH","col":"styles_col__19Ycq","fulfillmentStatus":"styles_fulfillmentStatus__2Av7Y","emailCol":"styles_emailCol__yGfpa"};